export const MaxProductQty = 10;
